"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processConsoleLogMessages = exports.enableConsoleLogForTest = exports.disableConsoleLogForTest = void 0;
const createConsoleLogMessages_1 = require("./createConsoleLogMessages");
let disabled = false;
exports.disableConsoleLogForTest = () => {
    disabled = true;
};
exports.enableConsoleLogForTest = () => {
    disabled = false;
};
exports.processConsoleLogMessages = async ({ actions, sourceMaps }) => {
    if (!disabled) {
        const logs = await createConsoleLogMessages_1.createConsoleLogMessages(actions, sourceMaps);
        if (logs.length > 0) {
            console.log(logs.join('\n\n'));
        }
    }
};

//# sourceMappingURL=processConsoleLogMessages.js.map
